"use client";

import { AlertCircle, AlertTriangle, CheckCircle2, Info } from "lucide-react";
import { Toaster } from "sonner";

// Brand wrapper around sonner's <Toaster>. Two reasons it exists:
//   1. DESIGN.md is squared — sonner's default toast is rounded, so we
//      flatten the radius and reskin the surface to the cream/ink/line
//      tokens with the documented card shadow.
//   2. The status icons are recoloured to the same tones <InlineNotice>
//      uses (sage success, warm-red error, gold warning) so a toast and
//      an inline notice read as the same system.
//
// Lives in a client component because the `icons` prop carries JSX and
// sonner's <Toaster> is itself a client component; keeping it out of the
// server-rendered root layout avoids any RSC serialisation ambiguity.

export function PortalToaster() {
  return (
    <Toaster
      position="bottom-right"
      theme="light"
      closeButton
      richColors={false}
      gap={10}
      icons={{
        success: <CheckCircle2 size={18} style={{ color: "var(--color-status-accepted)" }} />,
        error: <AlertCircle size={18} style={{ color: "var(--color-danger)" }} />,
        warning: <AlertTriangle size={18} style={{ color: "var(--color-accent-dark)" }} />,
        info: <Info size={18} style={{ color: "var(--color-muted)" }} />,
      }}
      toastOptions={{
        style: {
          borderRadius: "var(--toast-radius, 0)",
          border: "1px solid var(--color-line)",
          background: "var(--color-card)",
          color: "var(--color-ink)",
          fontFamily: "var(--font-sans)",
          boxShadow: "0 18px 40px -22px rgba(27,24,20,0.22)",
        },
      }}
    />
  );
}
